import { disable, enable } from '@leprecoins/effector';
import { createEvent, createStore } from 'effector';

const $routeLoading = createStore(false);

const routeLoadingStarted = createEvent();

const routeLoadingFinished = createEvent();

enable(routeLoadingStarted, $routeLoading);

disable(routeLoadingFinished, $routeLoading);

export const sharedModel = {
	$routeLoading,
	routeLoadingStarted,
	routeLoadingFinished,
};
